import React from 'react';
import classNames from 'classnames';

import css from './BrandLockup.module.css';

const MARK = '/static/branding/sweet-listeners-ear-heart.png';

/**
 * Official thick ear-heart (charcoal outer + pink inner) plus wordmark.
 * Intrinsic 558×448, contain, no cover crop and no scale zoom.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.size] compact | default | footer | header | menu
 * @returns {JSX.Element}
 */
const BrandLockup = props => {
  const { className, size = 'default' } = props;
  const hideTagline = size === 'menu';
  return (
    <span className={classNames(css.root, css[size], className)}>
      <span className={css.markFrame}>
        <img src={MARK} alt="Sweet Listeners" className={css.markImg} width={558} height={448} />
      </span>
      <span className={css.text}>
        <span className={css.wordmark}>
          <span className={css.sweet}>Sweet</span> <span className={css.listeners}>Listeners</span>
        </span>
        {hideTagline ? null : <span className={css.tagline}>Listen. Care. Connect. Learn.</span>}
      </span>
    </span>
  );
};

export default BrandLockup;
